<template>
    <div class="login container">
        <div class="login__holder">
            <div class="login-block--form login__box">
                <transition name="fade-in">
                    <div class="login-block__form">
                        <transition name="fade">
                            <ValidationObserver v-slot="{ handleSubmit }">
                                <form action="" class="login-form forget-pass--form" @submit.prevent="handleSubmit(submit); checkPassword">
                                    <div class="login-form__top">
										<h2 v-if="!invite" class="block-title login-form--title">Reset Password</h2>
										<h2 v-else class="block-title login-form--title">Set Password</h2>
                                        <p class="login-form--text">Enter New Password</p>
                                    </div>
									<div class="notification-wrap-form">
										<PartNotifications :data="notificationsData" @closeNotificaiton="closeNotificaiton" v-if="notificationsData.msg" />
									</div>
                                    <div class="login-form__body">
                                        <div class="login-form-fieldset login-form-fieldset--password input-holder">
                                            <label for="password" id="password-label" class="input-label">{{ label }}</label>
                                            <div class="input-holder__pass">
                                                <ValidationProvider :rules="`required`" v-slot="{ errors }" class="error-message-holder error-message-holder--block">
													<div>
														<PartInputBasic v-model="password" @checkPassword="checkPassword" :data="DataInputPassword"/>
														<a href="javascript:;" class="show-pass" @click="showPass" v-if="password">
															<SvgIcon class="show-pass__icon" :iconName="passIcon"/>
														</a>
													</div>
													<span class="error-message">{{ errors[0]}}</span>
                                                </ValidationProvider>
                                            </div>
											<div class="login-form__reset-password-condition">
												<span class="login-form__reset-password-condition-title">Password must contain at least:</span>
												<ul class="login-form__reset-password-condition-list">
													<li class="login-form__reset-password-condition-item" v-bind:class="{ is_valid: contains_eight_characters }">
														8 Characters
													</li>
													<li class="login-form__reset-password-condition-item" v-bind:class="{ is_valid: contains_number }">
														One Number
													</li>
													<li class="login-form__reset-password-condition-item" v-bind:class="{ is_valid: contains_uppercase }">
														One Uppercase letter
													</li>
													<li class="login-form__reset-password-condition-item" v-bind:class="{ is_valid: contains_special_character }">
														One Special Character
													</li>
												</ul>
											</div>
                                        </div>
                                    </div>
                                    <div class="login-form-fieldset login-form--submit error-message-holder">
                                        <button type="submit" class="btn login-form-submit-btn" id="login_reset-button" :class="{'login-form-submit-btn--disabled': !valid_password}" :disabled="!valid_password">
											<PartLoader v-if="showLoader"/>
											{{ invite ? 'Set Password' : 'Reset Password' }}
										</button>
                                        <div class="login-form__fp">
											<router-link :to="link" id="reset_back_login-button">Back to Login</router-link>
                                        </div>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </transition>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import PartInputBasic from '@/components/parts/PartInputBasic';
import { required } from 'vee-validate/dist/rules';
import PartLoader from '@/components/parts/PartLoader';
import PartNotifications from '@/components/parts/PartNotifications';

extend('required', {
	...required,
	message: 'This field is mandatory.'
});

export default {
	components: {
		SvgIcon,
		ValidationProvider,
		ValidationObserver,
		PartInputBasic,
		PartLoader,
		PartNotifications
	},
	data () {
		return {
			password_length: 0,
			contains_eight_characters: false,
			contains_number: false,
			contains_uppercase: false,
			contains_special_character: false,
			valid_password: false,
			notificationsData: {
				type: '',
				msg: '',
				hasCloseIcon: true
			},
			email: '',
			token: '',
			password: 'null',
			showLoader: false,
			errorMessage: false,
			LoginPass: true,
			pageIsLoaded: false,
			passIcon: 'ico-eye',
			label: 'New Password',
			DataInputPassword: {
				inputId: 'password-reset-input',
				name: 'Password',
				type: 'password',
				inputVal: 'password',
				disabled: false
			},
			minCharsRequired: 8,
			invite: false
		};
	},
	computed: {
		link() {
			// Append email to forgot-password email if valid
			if (this.email) {
				return `/login?email=${this.email}`;
			}

			return '/login';
		}
	},
	created() {
		this.email = this.$route.query.email;
		this.token = this.$route.params.token;
		this.checkToken();
		const url = new URL(window.location.href);
		if (url.searchParams.get('invite')) {
			this.invite = true;
		}
	},
	methods: {
		closeNotificaiton() {
			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 500);
		},
		checkPassword() {
			this.password_length = this.password.length;
			const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

			if (this.password_length > 8) {
				this.contains_eight_characters = true;
			} else {
				this.contains_eight_characters = false;
			}

			this.contains_number = /\d/.test(this.password);
			this.contains_uppercase = /[A-Z]/.test(this.password);
			this.contains_special_character = format.test(this.password);

			if (this.contains_eight_characters === true &&
				this.contains_special_character === true &&
				this.contains_uppercase === true &&
				this.contains_number === true) {
				this.valid_password = true;
			} else {
				this.valid_password = false;
			}
		},
		showPass() {
			const passwordField = document.querySelector('#password-reset-input');
			if (passwordField.getAttribute('type') === 'password') {
				passwordField.setAttribute('type', 'text');
				this.passIcon = 'ico-eyeslash';
			} else {
				passwordField.setAttribute('type', 'password');
				this.passIcon = 'ico-eye';
			}
		},

		checkToken() {
			this.$store.dispatch('testResetPasswordToken', this)
				.then()
				.catch(error => {
					if (error?.response?.data?.status === 'token_invalid') {
						this.DataInputPassword.disabled = true;
						this.handleTokenExpiredError();
					}
				});
		},

		submit() {
			// Bail if already in progress
			if (this.showLoader || this.errorMessage) {
				return;
			}

			this.showLoader = true;
			
			this.$store.dispatch('resetPassword', this)
				.then(response => {
					this.$router.push('/login?reset=1');
				})
				.catch(error => {
					if (error?.response?.data?.status === 'token_invalid') {
						this.handleTokenExpiredError();
					}
				});
		},
		notification(err) {
			this.notificationsData.msg = err;
			this.notificationsData.type = 'danger';
		},

		handleTokenExpiredError() {
			const noticeText = 'The link has expired, please request a new email with the password reset link.';
			this.notification(noticeText);
		}
	}
};
</script>
<style lang="scss" scoped>
.login-block__form {
	text-align: center;
}

.login-form--text {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	color: $fiord;
}

.login-form-fieldset {
	margin-bottom: 20px;
}

.login-form {
	input {
		display: block;
		box-shadow: none;
		border: 1px solid $grey-light;
		padding: 15px 20px;
		line-height: 1.2;
		width: 100%;
		font-size: 14px;
		font-family: $font-main;
		color: $fiord;
		transition: $dur $ease;
		background-color: $white;

		&:focus {
			border: 1px solid $dodger-blue;
		}

		@include placeholder {
			color: $grey;
		}
	}
}

.login__holder {
    display: flex;
    min-height: calc(100vh - 190px);

	@include mq($xl) {
		min-height: auto;
		padding: 60px 0;
	}

	@include mq($lg) {
		padding: 40px 0;
	}
}

.login__box {
    display: flex;
    align-items: center;
    justify-content: center;
	width: 100%;
}

.login-block__form {
    width: 100%;
    max-width: 387px;
    padding: 0 15px;
}

.login-form--title {
    margin-bottom: 20px;
}

.login-form--text {
    color: $fiord;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.08px;
    line-height: 21.6px;
}

.login-form__body {
    padding: 67px 0 0;
}

.login-form-submit-btn {
    width: 100%;
    position: relative;
	cursor: pointer;

	&--disabled {
		cursor: not-allowed;
		@include hover {
			background-color: $dodger-blue;
			color: $white;
		}
	}
}

.login-form__fp {
    display: flex;
    justify-content: flex-end;
    margin-top: 26px;
	align-self: center;

	a {
		color: $fiord;
		transition: $dur $ease;

		@include hover {
            opacity: 0.9;
            color: $dodger-blue;
        }
	}
}

.login-form__signup {
    font-size: 16px;
    letter-spacing: 0.1px;
    line-height: 1.2;
    font-weight: 400;
    color: $fiord;

    a {
        color: $fiord;
        transition: $dur $ease;
        font-weight: 700;

        @include hover {
            opacity: 0.9;
            color: $dodger-blue;
        }
    }
}

.login-form--submit {
    padding-top: 10px;
    margin-bottom: 64px;
    position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;

}

.forget-pass--form {
    .login-form-body {
        padding-top: 40px;
    }
}

.input-label {
	text-align: left;
}

.block-title {
	display: block;
	font-family: $font-main;
	font-weight: 500;
	font-size: 24px;
	line-height: 1.2;
	color: $fiord;
}

.btn {
	max-width: 250px;
	position: relative;
}

.input-holder,
.input-holder__pass {
	position: relative;
}

.show-pass {
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translateY(-50%);
	font-size: 14px;
	color: $fiord;
	transition: $dur $ease;

	@include hover {
		color: $dodger-blue;
	}
}

.error-message {
	bottom: 0;
	line-height: 1.5;
}

.login-form__reset-password-condition-title {
	text-align: left;
	margin-bottom: 10px;
	align-self: flex-start;
	justify-self: flex-start;
	display: flex;
	color: $fiord;
	font-size: 16px;
	line-height: 20px;
	font-family: $font-main;
}

.login-form__reset-password-condition-list {
	padding-left: 20px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	list-style-type: circle;
}

.login-form__reset-password-condition-item {
	margin-bottom: 8px;
	color: $fiord;
	font-size: 14px;
	line-height: 20px;
	font-family: $font-main;
	position: relative;
	list-style-type: circle;

	&::before {
		content: '';
		width: 0%; height: 2px;
		background: $green;
		position: absolute;
		left: 0;
		top: 44%;
		display: block;
		transition: all .6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
	}
}

.is_valid {
	color: rgba(136, 152, 170, 0.8);
}
.is_valid:before {
	width: 100%;
}

.checkmark_container {
	border-radius: 50%;
	position: absolute;
	top: -15px; right: -15px;
	background: $green;
	width: 50px; height: 50px;
	visibility: hidden;
	opacity: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: opacity .4s ease;
}

.show_checkmark {
	visibility: visible;
	opacity: 1;
}

.checked {
	animation: draw 0.5s ease forwards;
}

@keyframes draw {
	to {
		stroke-dashoffset: 0;
	}
}
</style>
